import aituBridge from "@btsd/aitu-bridge";

export const copyLinkToClipboard = async (
  text: string,
  onSuccess?: () => void
) => {
  if (aituBridge.isSupported()) {
    await aituBridge.copyToClipboard(text);
  } else {
    await navigator.clipboard.writeText(text);
  }
  onSuccess?.();
};
